import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"

import {
  DRAWERS_PARAM_NAME,
  QUICK_WINS_DRAWER_ID,
  WIDTH_DEFAULT
} from "@/organisms/Drawers/const"
import { getIdsDrawer } from "@/organisms/Drawers/hooks/useDrawer"
import { TabsDrawerTemplate } from "../TabsDrawerTemplate"
import {
  IgnoredTabQuickWins,
  SuggestedTabQuickWins
} from "./components/QuickWinsTabContent"
import { QuickWinsTitle } from "./components/QuickWinsTitle"

import styles from "./QuickWinsDrawer.module.scss"

import type { QuickWinsDrawerProps } from "."

const TABS = ["suggested", "ignored"]
const COMPONENTS = [SuggestedTabQuickWins, IgnoredTabQuickWins]

export const QuickWinsDrawer = (props: QuickWinsDrawerProps) => {
  const { widthAdditive, ...restProps } = props
  const [searchParams, setSearchParams] = useSearchParams()

  // Intentional: Close older QuickWins drawer instances to prevent infinite QW → Issue → QW stacking.
  // Runs once on mount — uses the initial searchParams snapshot to deduplicate (Round 3 design decision).
  useEffect(() => {
    const ids = getIdsDrawer(searchParams)
    const qwIds = ids.filter(
      (did) => did[0] === QUICK_WINS_DRAWER_ID && did !== props.id
    )

    if (!qwIds.length) return

    const nextIds = ids.filter((did) => !qwIds.includes(did))

    qwIds.forEach((qwId) => {
      searchParams.delete(qwId)
      searchParams.delete(`${qwId}_at`)
    })

    if (nextIds.length) {
      searchParams.set(DRAWERS_PARAM_NAME, nextIds.toString())
    } else {
      searchParams.delete(DRAWERS_PARAM_NAME)
    }

    setSearchParams(searchParams)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <TabsDrawerTemplate
      name="QuickWinsDrawer"
      tabs={TABS}
      components={COMPONENTS}
      width={WIDTH_DEFAULT + widthAdditive}
      Title={QuickWinsTitle}
      controlledActiveKey
      classes={{ drawer: styles.drawer }}
      {...restProps}
    />
  )
}
